import axios from 'axios';

export const contactUsService = async (data: any) => {
  const url = 'https://clickagentapp.com/api/agentProfile/contactUs';
  return (await axios.post(url, data));
}
